import { computed } from 'vue';
import { getCredentials } from '@/utils/auth';

export function usePermissions() {
  const credentials = computed(() => getCredentials() ?? {});
  const isAdmin = computed(() => Boolean(credentials.value.is_admin));
  const permissions = computed(() => credentials.value.permissions ?? []);
  const isLegacySession = computed(
    () => Boolean(credentials.value.username) && typeof credentials.value.permissions === 'undefined'
  );

  const can = (permission) =>
    !permission ||
    isAdmin.value ||
    isLegacySession.value ||
    permissions.value.includes('*') ||
    permissions.value.includes(permission);

  const canAny = (requestedPermissions = []) => requestedPermissions.some((permission) => can(permission));

  return {
    credentials,
    isAdmin,
    permissions,
    can,
    canAny
  };
}
